import { registerComponent } from '@gig/magic-common';
import SummedTransactionTotalsComponent from './summed-totals.vue.js';

var SummedTransactionTotals = registerComponent(SummedTransactionTotalsComponent);

export { SummedTransactionTotals };
